// extracted by mini-css-extract-plugin
export default {"FullScreenOverlay":"FullScreenOverlay_FullScreenOverlay__fgYUa"};